import { Dispatch, SetStateAction } from 'react';
import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { generateConsistencyCheckBranches } from '@api/consistencyCheck';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IConsistencyCheckBranchesDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';
import { IResponseError } from '@interfaces/errors/apiErrors';

import { CONSISTENCY_GENERATE } from '@constants/queryKeys';

interface IUseMutateConsistencyCheckMutationsReturnType {
	dumpId?: string;
	generateBranches: UseMutateFunction<{ dumpId: string }, any, IConsistencyCheckBranchesDTO, any>;
	isLoadingBranchesGenerated: boolean;
}

const useMutateConsistencyCheckMutations = (
	setIsProgressRun: Dispatch<SetStateAction<boolean>>,
): IUseMutateConsistencyCheckMutationsReturnType => {
	const {
		data: generatedBranches,
		mutate: generateBranches,
		isLoading: isLoadingBranchesGenerated,
	} = useMutation<IConsistencyCheckBranchesDTO, { dumpId: string }>({
		mutationKey: [CONSISTENCY_GENERATE],
		mutationFn: generateConsistencyCheckBranches,
		onError: (err: IResponseError) => {
			setIsProgressRun(false);
			handleErrorFromMessage(err);
		},
	});

	return {
		dumpId: generatedBranches?.dumpId,
		generateBranches,
		isLoadingBranchesGenerated,
	};
};

export default useMutateConsistencyCheckMutations;
